<template>
  <div class="animated fadeIn">
    <basic-heading title="New Analyte" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add analyte'">
      <template #gated-content>
        <analyte-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import AnalyteForm from "@/components/lab/analyte/AnalyteForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { notificationOptions } from "@/shared/toast-notification-options";
import { analyteNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const AnalyteRepository = LabRepositoryFactory.get("analyte");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "AnalyteAdd",
  components: {
    AnalyteForm,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/analytes",
            title: "Analyte list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        const { data } = await AnalyteRepository.create(form_data);

        this.addSuccess();
        this.$router.push(`/analytes/${data.id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: analyteNotifications,
};
</script>
